import { generatePath } from "@routes/utils";

import type { IExtractParams } from "@routes";

const pathBase = `/users/:userId/set-password/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const setPassword = {
  post: (param: IPathBaseParam) => generatePath(pathBase, param),
};
